import { Component, input } from '@angular/core';

@Component({
  selector: 'app-point-list-line',
  standalone: true,
  imports: [],
  templateUrl: './point-list-line.component.html',
  styleUrls: ['./point-list-line.component.scss'],
})
export class PointListLineComponent {
  public lineHeight = input.required<number>();

  public getArrayAccordingToTheNumberOfPointsForWalkTransfer(totalHeight: number): any[] {
    const numberOfPoints = this.getNumberOfPointsForWalkTransfer(totalHeight);
    return Array.from({ length: numberOfPoints });
  }
  
  public getNumberOfPointsForWalkTransfer(totalHeight: number): number {
    const pointHeight = 8;
    const gapBetweenPoints = 6;
    const totalPointHeight = pointHeight + gapBetweenPoints;
    return Math.floor(totalHeight / totalPointHeight);
  }
}
